import React from 'react';
type StatCardProps = {
  label: string;
  value: string;
  caption: string;
  tone?: 'default' | 'danger';
};
export function StatCard({
  label,
  value,
  caption,
  tone = 'default'
}: StatCardProps) {
  const isDanger = tone === 'danger';
  return <div className={['rounded-xl border bg-white px-5 py-4', isDanger ? 'border-danger/40' : 'border-gray-200'].join(' ')} data-id="element-221" data-mp="oimle3o7peda">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500" data-id="element-222" data-mp="emjigvljdbpa">
        {label}
      </p>
      <p className={['mt-2 text-3xl font-bold leading-none', isDanger ? 'text-danger' : 'text-ink'].join(' ')} data-id="element-223" data-mp="ajmz32o69bka">
        {value}
      </p>
      <p className={['mt-3 text-[12px]', isDanger ? 'text-danger' : 'text-gray-500'].join(' ')} data-id="element-224" data-mp="nbi3zdmzxji">
        {caption}
      </p>
    </div>;
}